module.exports = __webpack_public_path__ + "img/illustration-manager-and-project-manager.0b37525f.png";